var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Pn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0074 29.8012L26.8824 27.9338C26.6462 27.5175 26.4324 26.73 26.4324 26.2688V23.4225C26.4324 20.7787 24.8799 18.495 22.6412 17.4262C22.0562 16.3913 20.9762 15.75 19.7387 15.75C18.5124 15.75 17.4099 16.4137 16.8249 17.46C14.6312 18.5512 13.1124 20.8125 13.1124 23.4225V26.2688C13.1124 26.73 12.8987 27.5175 12.6624 27.9225L11.5262 29.8012C11.0762 30.555 10.9749 31.3875 11.2562 32.1525C11.5262 32.9062 12.1674 33.4913 12.9999 33.7725C15.1824 34.515 17.4774 34.875 19.7724 34.875C22.0674 34.875 24.3624 34.515 26.5449 33.7838C27.3324 33.525 27.9399 32.9287 28.2324 32.1525C28.5249 31.3763 28.4462 30.5212 28.0074 29.8012Z",
    fill: "url(#paint0_linear_48_1583)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9339 36.0113C22.4614 37.3163 21.2126 38.25 19.7501 38.25C18.8614 38.25 17.9839 37.89 17.3651 37.2488C17.0051 36.9113 16.7351 36.4613 16.5776 36C16.7239 36.0225 16.8701 36.0337 17.0276 36.0562C17.2864 36.09 17.5564 36.1237 17.8264 36.1462C18.4676 36.2025 19.1201 36.2362 19.7726 36.2362C20.4139 36.2362 21.0551 36.2025 21.6851 36.1462C21.9214 36.1237 22.1576 36.1125 22.3826 36.0787C22.5626 36.0562 22.7426 36.0338 22.9339 36.0113Z",
    fill: "url(#paint1_linear_48_1583)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1583)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 9,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    fill: "url(#paint2_linear_48_1583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.456 16.7852C32.1272 16.7852 31.8268 17.0429 31.8413 17.3713C31.8569 17.7231 31.5763 18.0132 31.228 18.0132H30C29.6608 18.0132 29.3859 17.7383 29.3859 17.3992C29.3859 17.0601 29.111 16.7852 28.7719 16.7852H27.5439C27.0578 16.7852 26.5906 16.8658 26.1549 17.0146C24.4628 17.5921 23.2458 19.1956 23.2458 21.0832C23.2458 23.457 25.1702 25.3813 27.5439 25.3813C27.6882 25.3813 30.705 25.401 31.5962 22.3546C31.9152 21.2641 32.8469 20.4692 33.9831 20.4692H36.5084C37.1867 20.4692 37.7365 19.9194 37.7365 19.2412V18.0132C37.7365 17.335 37.1867 16.7852 36.5084 16.7852H32.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4912 11.873V13.1011V11.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4912 11.873V13.1011",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8862 13.4607L28.7546 14.329L27.8862 13.4607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8862 13.4607L28.7546 14.329",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0961 13.4607L32.2278 14.329L33.0961 13.4607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0961 13.4607L32.2278 14.329",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.6211,
    cy: 21.2479,
    r: 1.5,
    fill: "url(#paint3_linear_48_1583)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_1583",
    x1: 11.0994,
    y1: 23.8781,
    x2: 28.406,
    y2: 23.8781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_1583",
    x1: 16.5776,
    y1: 36.9562,
    x2: 22.9339,
    y2: 36.9562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_48_1583",
    x1: 29.5,
    y1: 9,
    x2: 29.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_48_1583",
    x1: 26.6211,
    y1: 19.7479,
    x2: 26.6211,
    y2: 22.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 9,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Pn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2pn.1fa1e90f.svg";
export { ForwardRef as ReactComponent };